import React, { createContext, useCallback, useContext, useEffect } from "react";

import { GET_APP_GAMES } from "graphql/query/game-gql";
import { GET_APP_DOCUMENTS } from "graphql/query/document-gql";
import { hasPortalValue } from "components/game/game-link";
import usePaginatedAppContent from "./use-paginated-app-content";

const AppContentContext = createContext(null);

export const AppContentProvider = ({ authToken, children }) => {
    const isSessionCurrent = useCallback(() => (
        !!authToken && localStorage.getItem("authToken") === authToken
    ), [authToken]);
    const games = usePaginatedAppContent(GET_APP_GAMES, "games", isSessionCurrent);
    const documents = usePaginatedAppContent(GET_APP_DOCUMENTS, "documents", isSessionCurrent);
    const loadGames = games.refresh;
    const loadDocuments = documents.refresh;

    useEffect(() => {
        loadDocuments();
    }, [loadDocuments]);

    useEffect(() => {
        if (hasPortalValue(localStorage.getItem("jwtAuth")) && hasPortalValue(localStorage.getItem("jwtToken"))) {
            loadGames();
        }
    }, [loadGames]);

    return (
        <AppContentContext.Provider value={{ games, documents }}>
            {children}
        </AppContentContext.Provider>
    );
};

export const useAppContent = () => {
    const content = useContext(AppContentContext);
    if (!content) throw new Error("App content requires AppContentProvider");
    return content;
};
